import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// // 个人中心
import personRouter from './modules/person';

//根路由 放置了： 登录页面   404页面  不需要权限的页面
export var constantRouterMap = [{
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/401');
  },
  hidden: true
},
// 运营监控图-人事
{
  path: '/operateWatchTable',
  component: function component() {
    return import('@/views/operateWatchTable/index');
  },
  hidden: true
},
// 运营监控图-个人
{
  path: '/operateWatchTablePerson',
  component: function component() {
    return import('@/views/operateWatchTable/show_person');
  },
  hidden: true
},
// 运营监控图-业务-西安
{
  path: '/operateWatchTableShow',
  component: function component() {
    return import('@/views/operateWatchTable/show');
  },
  hidden: true
},
// 运营监控图-业务--北京
{
  path: '/operateWatchTableShowBJ',
  component: function component() {
    return import('@/views/operateWatchTable/show_bj');
  },
  hidden: true
},
// 运营监控图-业务--成都
{
  path: '/operateWatchTableShowCD',
  component: function component() {
    return import('@/views/operateWatchTable/show_cd');
  },
  hidden: true
},

/*
  {
    path: '/',
    redirect: '/homePage/page1',
    hidden: true
  },
*/

{
  path: '/EmployeeAdd',
  component: function component() {
    return import('@/views/employeeManage/EmployeeAdd');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/EmployeeEdit',
  component: function component() {
    return import('@/views/employeeManage/EmployeeEdit');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/EmployeeDetail',
  component: function component() {
    return import('@/views/employeeManage/EmployeeDetail');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/AchievementDetail',
  component: function component() {
    return import('@/views/employeeManage/AchievementDetail');
  },
  hidden: true,
  meta: { next: true }
},
/*  {
    path: '/AchievementDetail',
    component: () => import('@/views/employeeManage/AchievementDetail'),
    hidden: true
  },*/

{
  path: '/salaryEmployeeDetail',
  component: function component() {
    return import('@/views/salary/salaryEmployeeDetail');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/addSalaryEmployeeDetail',
  component: function component() {
    return import('@/views/salary/addSalaryEmployeeDetail');
  },
  hidden: true,
  meta: { next: true }

}, {
  path: '/editSalaryEmployeeDetail',
  component: function component() {
    return import('@/views/salary/editSalaryEmployeeDetail');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/salaryPaidChildDetail',
  component: function component() {
    return import('@/views/salary/salaryPaidChildDetail');
  },
  hidden: true,
  meta: { next: true }
}, {
  path: '/salaryPaidParentDetail',
  component: function component() {
    return import('@/views/salary/salaryPaidParentDetail');
  },
  hidden: true,
  meta: { next: true }
},

// 查看放款信息
{
  path: '/viewLoanInfo',
  component: function component() {
    return import('@/views/loan/viewLoanInfo');
  },
  hidden: true,
  meta: { next: true }
},

// 确认放款
{
  path: '/confirmLoan',
  component: function component() {
    return import('@/views/loan/confirmLoan');
  },
  hidden: true,
  meta: { next: true }
},

// 上传凭证
{
  path: '/uploadVoucher',
  component: function component() {
    return import('@/views/loan/uploadVoucher');
  },
  hidden: true,
  meta: { next: true }
},

// 查看线下放款信息
{
  path: '/viewOfflineLoanInfo',
  component: function component() {
    return import('@/views/loan/viewOfflineLoanInfo');
  },
  hidden: true,
  meta: { next: true }
},

// 线下放款手动制单
{
  path: '/manualProduction',
  component: function component() {
    return import('@/views/loan/manualProduction');
  },
  hidden: true,
  meta: { next: true }
},

// 查看收款信息
{
  path: '/viewReceivablesInfo',
  component: function component() {
    return import('@/views/receivables/viewReceivablesInfo');
  },
  hidden: true,
  meta: { next: true }
},

// 确认收款
{
  path: '/confirmReceivables',
  component: function component() {
    return import('@/views/receivables/confirmReceivables');
  },
  hidden: true,
  meta: { next: true }
},

// 查看退息
{
  path: '/viewReceivablesInterestRebate',
  component: function component() {
    return import('@/views/receivables/viewReceivablesInterestRebate');
  },
  hidden: true,
  meta: { next: true }
},

// 确认退息
{
  path: '/confirmReceivablesInterestRebate',
  component: function component() {
    return import('@/views/receivables/confirmReceivablesInterestRebate');
  },
  hidden: true,
  meta: { next: true }
},

// 线下确认收款
{
  path: '/offlineConfirmReceivables',
  component: function component() {
    return import('@/views/receivables/offlineConfirmReceivables');
  },
  hidden: true,
  meta: { next: true }
}, personRouter
// {
//   path: '*',
//   redirect: '/404',
//   hidden: true
// }
];
//创建路由实例
export default new Router({
  // mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
});
//需要访问权限的页面
/*export const asyncRouterMap = [
  customerRouter,
  managerRouter,
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]*/